import { render, staticRenderFns } from "./BookDisplayPanel.vue?vue&type=template&id=3f3e2de5&"
import script from "./BookDisplayPanel.vue?vue&type=script&lang=js&"
export * from "./BookDisplayPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports